import { FunctionalComponent, h } from 'preact';
import { ChevronLeft } from 'preact-feather';
import styled from 'styled-components';
import { useLocaleData } from '@primer-sdk-web/utils/hooks';
import { BaseButton } from '../Button';

const Root = styled(BaseButton)`
  width: auto;
  z-index: 1;
  padding: 8px;
  margin: -8px;

  ${(p) => ({ color: p.theme.style?.backButton?.color })}
  ${(p) => p.isRtlLocale && { transform: 'rotate(180deg)' }}
`;

type Props = {
  disabled?: boolean;
  onClick: () => void;
};

const BackButton: FunctionalComponent<Props> = ({ disabled, onClick }) => {
  const { isRtlLocale } = useLocaleData();

  return (
    <Root
      disabled={disabled}
      type='button'
      data-testid='Scene.backButton'
      id='primer-checkout-go-back'
      className='PrimerCheckout__backButton'
      isRtlLocale={isRtlLocale}
      onClick={onClick}
    >
      <ChevronLeft className='icon' />
    </Root>
  );
};

export default BackButton;
